import {Deposit} from './deposit';
import {Payout} from './payout';
export class Payment {
  payout: Payout = new Payout();
  deposit: Deposit = new Deposit();

  static CloneForCreateTranaction(payment: Payment, validation?: boolean) {
    const clone = new Payment();
    clone.payout = Payout.CloneForCreateTranaction(payment.payout, validation);
    clone.deposit = Deposit.CloneForCreateTranaction(payment.deposit, validation);
    return clone;
  }
}

export class ReqPayoutRate {
  customer_rate?: number;
  type?: string;
  amount?: number;
  partner_id?: string;
}

export class ReqDepositRate {
  amount?: number;
  fee?: number;
  fee_force?: boolean;
}

export enum AmountType {
  Payout, Deposit
}
export class ReqPaymentRate {
  constructor(param: Payment, type: AmountType) {
    if (type === AmountType.Payout) {
      this.payout.amount = param.payout.amount;
    } else if (type === AmountType.Deposit) {
      this.deposit.amount = param.deposit.amount;
    }
    this.payout.customer_rate = param.payout.customer_rate;
    this.payout.type = param.payout.type;
    this.payout.partner_id = param.payout.partner_id;
    this.deposit.fee = param.deposit.fee;
    this.deposit.fee_force = param.deposit.fee_force;
  }

  parseResponse(response, type: AmountType) {
    if (type === AmountType.Payout) {
      this.deposit.amount = response.deposit.amount;
    } else if (type === AmountType.Deposit) {
      this.payout.amount = response.payout.amount;
    }
    this.payout.customer_rate = response.payout.customer_rate;
    this.deposit.fee = response.deposit.fee;
    return this;
  }

  payout: ReqPayoutRate = new ReqPayoutRate();
  deposit: ReqDepositRate = new ReqDepositRate();
}


// WEBPACK FOOTER //
// ./src/app/model/shared/transaction/payment.ts